"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = require("@opentelemetry/api");
const sys_level_1 = require("./sys-level");
const version_1 = require("./version");
const otlAngularConfig = (config) => {
    const { appPrefix, serviceName, sysLevel = '' } = config;
    const blankAppPrefix = appPrefix.trim() === '';
    if (blankAppPrefix) {
        return {
            commonConfig: { serviceName, console: false, probabilitySampler: '0' },
        };
    }
    const sysLevelPreset = sys_level_1.getSysLevelPresetFromEnv(sysLevel);
    return {
        commonConfig: {
            console: sysLevelPreset.exportSpansToConsole,
            production: sysLevelPreset.batchSpansToCollector,
            serviceName,
            logBody: false,
            probabilitySampler: '1',
            logLevel: api_1.DiagLogLevel.NONE,
        },
        batchSpanProcessorConfig: {
            maxQueueSize: '10240',
            maxExportBatchSize: '5120',
            scheduledDelayMillis: '3000',
            exportTimeoutMillis: '30000',
        },
        otelcolConfig: {
            url: `https://${sysLevelPreset.collectorDomain}:443/v1/traces`,
            attributes: {
                'telemetry.config.builder.name': '@vanguard/otl-vanguard-wrapper',
                'telemetry.config.builder.version': version_1.LIB_VERSION,
                'service.appprefix': appPrefix,
                ...config.additionalAttributes
            },
        },
    };
};
exports.default = otlAngularConfig;
//# sourceMappingURL=index.js.map